import { shouldSummarizeInsights } from "@blis/shared/insights/summarize-heuristic";

export function insightsLoadingMessage(question: string | null): string {
  if (!question) return "Running query…";
  if (shouldSummarizeInsights(question)) {
    return "Generating SQL, running query, and clustering themes…";
  }
  return "Generating SQL and running query…";
}

/** Label for the theme summary count column from aggregate SQL shape. */
export function insightsSummaryCountLabel(
  rows: Record<string, unknown>[],
): string {
  if (rows.length === 0) return "Count";
  const keys = Object.keys(rows[0]);
  if (keys.some((k) => /comment_count/i.test(k))) return "Comments";
  if (keys.some((k) => /report_count/i.test(k))) return "Reports";
  if (keys.some((k) => /accession_count/i.test(k))) return "Accessions";
  return "Count";
}
